/**
 * Created by HYL.
 * 项目相关api
 */
import * as API from './'

export default {
  
  // 项目列表
  projectList: params => {
    return API.GET('/api/project/pageList', params)
  },
  save: params => {
    return API.POST('/api/project/save', params)
  },
  update: params => {
    return API.POST('/api/project/update', params)
  },
  remove: id => {
    return API.GET('/api/project/remove/' + id)
  },
  //项目设备品类列表
  projectDeviceCategories: projectId => {
    return API.GET('/api/project/devicecategories/' + projectId)
  },
  getMyProject:params=>{
    return API.GET('/api/project/getMyProject', params)
  },
  projectCombox: params => {
    return API.GET('/api/project/combox', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/api_project.js